import { FileSpreadsheet, FileText, Download } from 'lucide-react';

export const ExportTab = ({
  invoiceMonth, setInvoiceMonth,
  invoiceYear, setInvoiceYear,
  exportBookings,
}) => {
  return (
    <div className="space-y-6 animate-fade-in-up">
      <div className="glass-card rounded-xl p-6">
        <h3 className="text-lg font-bold text-white font-['Outfit'] mb-4">Exporter les données comptables</h3>

        <div className="flex flex-wrap gap-4 items-end mb-6">
          <div>
            <label className="text-zinc-400 text-sm block mb-2">Mois</label>
            <select
              value={invoiceMonth}
              onChange={(e) => setInvoiceMonth(parseInt(e.target.value))}
              className="px-4 py-2 bg-zinc-800 border border-zinc-700 rounded-lg text-white"
            >
              {Array.from({ length: 12 }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                  {new Date(2024, i).toLocaleDateString('fr-FR', { month: 'long' })}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="text-zinc-400 text-sm block mb-2">Année</label>
            <select
              value={invoiceYear}
              onChange={(e) => setInvoiceYear(parseInt(e.target.value))}
              className="px-4 py-2 bg-zinc-800 border border-zinc-700 rounded-lg text-white"
            >
              {[2024, 2025, 2026].map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          <button
            onClick={() => exportBookings('excel')}
            className="flex items-center gap-4 p-6 bg-zinc-800 rounded-xl hover:bg-zinc-700 transition-colors"
            data-testid="export-excel-btn"
          >
            <div className="w-12 h-12 bg-emerald-500/20 rounded-xl flex items-center justify-center">
              <FileSpreadsheet className="w-6 h-6 text-emerald-400" />
            </div>
            <div className="text-left">
              <p className="text-white font-bold">Export Excel</p>
              <p className="text-zinc-400 text-sm">Fichier .xlsx avec détails HT/TVA/TTC</p>
            </div>
            <Download className="w-5 h-5 text-zinc-500 ml-auto" />
          </button>

          <button
            onClick={() => exportBookings('csv')}
            className="flex items-center gap-4 p-6 bg-zinc-800 rounded-xl hover:bg-zinc-700 transition-colors"
            data-testid="export-csv-btn"
          >
            <div className="w-12 h-12 bg-blue-500/20 rounded-xl flex items-center justify-center">
              <FileText className="w-6 h-6 text-blue-400" />
            </div>
            <div className="text-left">
              <p className="text-white font-bold">Export CSV</p>
              <p className="text-zinc-400 text-sm">Compatible logiciels comptables</p>
            </div>
            <Download className="w-5 h-5 text-zinc-500 ml-auto" />
          </button>
        </div>
      </div>
    </div>
  );
};
